/**
 * Description: i18n keys for Filter Template features
 * Created by: hbviet
 * Created date: 2025-01-22
 */

export default {
  // Template Selection
  SelectTemplate: 'Select template',
  NoTemplate: 'No template selected',
  
  // Save Template
  SaveTemplate: 'Save template',
  EditTemplate: 'Edit template',
  TemplateName: 'Template name',
  EnterTemplateName: 'Enter template name',
  TemplateNameRequired: 'Template name is required',
  TemplateNameTooLong: 'Template name cannot exceed 256 characters',
  TemplateNameInvalidChars: 'Template name contains invalid characters',
  TemplateNameExists: 'Template name already exists',
  ErrorCheckingName: 'Error checking template name',
  
  // Save Options
  SaveOptions: 'Save options',
  SaveChanges: 'Save changes',
  SaveAsCopy: 'Save as copy',
  CurrentTemplate: 'Current template',
  
  // Messages
  SaveTemplateSuccess: 'Template saved successfully',
  SaveTemplateFailed: 'Failed to save template',
  TemplateDataError: 'Invalid template data',
  
  // Delete Template
  DeleteTemplate: 'Delete template',
  DeleteTemplateConfirm: 'Are you sure you want to delete this template?',
  DeleteTemplateConfirmMessage: 'Are you sure you want to delete template "{name}"?',
  DeleteTemplateSuccess: 'Template deleted successfully',
  DeleteTemplateFailed: 'Failed to delete template',
  TemplateNotFound: 'Template not found',
  
  // Common
  Cancel: 'Cancel',
  Save: 'Save',
  Delete: 'Delete'
};